var _react_refresh_temp_1;
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { formatDate } from '#integrations';
import { Typography } from '../Typography';
export const DateDisplay = ({ color = 'default', 'data-testid': testid, date, fontWeight, kind = 'p-small', variant, }) => (_jsx(Typography, { color: color, fontWeight: fontWeight, kind: kind, ...(testid && { 'data-testid': testid }), children: renderDate(date, variant) }));
_react_refresh_temp_1 = DateDisplay;
$RefreshReg$(_react_refresh_temp_1, "DateDisplay");
const renderDate = (date, variant) => {
    switch (variant) {
        case 'date':
            return formatDate(date, 'dateOnly');
        case 'date-time':
            return formatDate(date, 'dateAndTime');
        case 'date-time-stacked':
            return (_jsxs(_Fragment, { children: [formatDate(date, 'dateOnly'), _jsx("br", {}), formatDate(date, 'timeOnly')] }));
    }
};
